// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBVKJIigcT3sfzt0eIN3z7Tf27h4dvga-s",
    authDomain: "booky-a6a30.firebaseapp.com",
    databaseURL: "https://booky-a6a30.firebaseio.com",
    projectId: "booky-a6a30",
    storageBucket: "booky-a6a30.appspot.com",
    messagingSenderId: "474191272686",
    appId: "1:474191272686:web:3dff14e9ca19dd334cf1ff",
    measurementId: "G-78GEZ0VJ2Q"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
